export const InfoIcon = ({
  color = 'yellow',
  className,
  onClick,
  iClassName,
  dataTestId,
}: {
  color?: 'green' | 'yellow' | 'white' | 'red' | 'black' | 'purple' | 'sweeps' | 'gold';
  className?: string;
  onClick?: () => void;
  iClassName?: string;
  dataTestId?: string;
}) => {
  return (
    <svg
      className={`info-icon info-icon__${color}${className ? ` ${className}` : ''}`}
      data-testid={dataTestId}
      fill="none"
      height="24"
      style={{ ...(onClick ? { cursor: 'pointer' } : {}) }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <rect height="24" rx="12" width="24" />
      <path
        className={iClassName}
        d="M10.1459 20.6409V8.50778H13.9656V20.6409H10.1459ZM12.0682 6.8351C11.469 6.8351 10.9697 6.63538 10.5703 6.23594C10.1875 5.81985 9.99609 5.32054 9.99609 4.73802C9.99609 4.13885 10.1875 3.63954 10.5703 3.2401C10.9697 2.84065 11.469 2.64093 12.0682 2.64093C12.6674 2.64093 13.1584 2.84065 13.5412 3.2401C13.924 3.63954 14.1154 4.13885 14.1154 4.73802C14.1154 5.32054 13.924 5.81985 13.5412 6.23594C13.1584 6.63538 12.6674 6.8351 12.0682 6.8351Z"
        fill={color == 'white' ? 'black' : 'white'}
      />
    </svg>
  );
};
